import List from "./List.js";
import Edit from "./Edit.js";
import Create from "./Create.js";

export default { List, Edit, Create };
